<template>
  <card
    v-if="!isLoadingImages && !isLoadingVideos && hasCorrectAmbito"
    :style="[
      isLarge
        ? {
            'max-width': '28rem',
            height: '45rem',
            'max-height': '45rem',
            'border-radius': '10px',
          }
        : {
            'max-width': '28rem',
            'max-sheight': '45rem',
            'border-radius': '10px',
          },
    ]"
    class="postcardattivita attivita orange pb-3"
    :class="isLarge ? 'mx-2' : ''"
  >
    <slider
      class="custom-image-slider"
      animation="fade"
      :autoplay="false"
      v-if="item.media !== undefined && item.media.length !== 0"
    >
      <slider-item v-for="(media, index) in item.media" :key="index">
        <img
          v-img="{ group:  screenSize + indexOfStrumento }"
          :src="media['o:thumbnail_urls']['large']"
          :alt="item['o:title']"
          class="img"
        />
      </slider-item>
    </slider>
    <slider
      class="custom-image-slider"
      animation="fade"
      :autoplay="false"
      v-else
    >
      <slider-item>
        <img
          v-img="{ group:  screenSize + indexOfStrumento }"
          :src="require('@/assets/images/noPhotoAvailable.png')"
          alt="Esperimento"
          class="img"
        />
      </slider-item>
    </slider>

    <div class="m-4">
      <h5 class="card-title text-center">
        <b>{{ item["o:title"] }}</b>
      </h5>

      <div
        :class="
          isLarge
            ? 'postcardattivita__tagbox mb-4'
            : 'postcardattivita__tagbox mb-4'
        "
      >
        <button
          :class="
            selectedTab === 'Descrizione'
              ? 'tag__item__selected'
              : 'tag__item__unselected'
          "
          v-on:click="selectedTab = 'Descrizione'"
        >
          Descrizione
        </button>
        <!-- <button
          :class="
            selectedTab === 'Immagini'
              ? 'tag__item__selected'
              : 'tag__item__unselected'
          "
          v-on:click="selectedTab = 'Immagini'"
        >
          Immagini
        </button> -->
        <button
          :class="
            selectedTab === 'Video'
              ? 'tag__item__selected'
              : 'tag__item__unselected'
          "
          v-on:click="selectedTab = 'Video'"
        >
          Video
        </button>
      </div>

      <div :class="{ 'text-justify ': !isMobile }">
        <div v-if="selectedTab === 'Panoramica'" class="col-12 px-0">
          <div
            class="text-left px-0 px-lg-3 description col-12 text-black text mt-3 overflow-auto"
          >
            <div>
              <div class="row mx-1 mb-2">
                <h6 class="mr-2">Situato in:</h6>
                <h6 class="font-weight-normal">
                  {{ item["geo:situato_in"][0]["display_title"].substring(6) }}
                  <!--In questo modo si rimuove il prefisso "PIVOT_"-->
                  <i class="bi bi-pin-map-fill mr-2"></i>
                </h6>
              </div>
            </div>
          </div>
        </div>
        
        <div v-else-if="selectedTab === 'Descrizione'" class="col-12 px-0">
          <div
            class="text-justify px-0 px-lg-3 description col-12 text-black text mt-3"
            style="overflow: auto"
          >
            <div>
              <div class="row mx-1 mb-2" v-if="!isGeodidalab">
                <h6 class="mr-2">Ambito:</h6>
                <h6 class="font-weight-normal">
                  {{ item["geo:appartiene_a_ambito"][0]["display_title"] }}
                </h6>
              </div>
              <div class="row mx-1 mb-2">
                <b>
                  {{ item["dcterms:description"][0]["@value"] }}
                </b>
              </div>
            </div>
          </div>
        </div>

        <!-- <div
          v-else-if="selectedTab === 'Immagini'"
          class="col-12 px-0 text-center"
        >
          <swiper
            v-if="item.media !== undefined && item.media.length !== 0"
            ref="mySwiperStrumenti"
            class="swiper"
            navigation
            :pagination="{ clickable: true }"
            style="background-color: hsl(17, 100%, 90%); border-radius: 10px"
          >
            <swiper-slide
              style="height: 250px"
              v-for="(media, index) in item['media']"
              :key="index"
            >
              <img
                v-img="{ group: indexOfStrumento }"
                :src="media['o:thumbnail_urls']['large']"
                :alt="item['o:title']"
                class="img"
              />
            </swiper-slide>

            <div
              v-if="item.media.length > 1"
              class="swiper-button-prev"
              slot="button-prev"
              @click="swiper.slidePrev()"
            ></div>
            <div
              v-if="item.media.length > 1"
              class="swiper-button-next"
              slot="button-next"
              @click="swiper.slideNext()"
            ></div>
          </swiper>

          <div
            v-if="item.media === undefined || item.media.length === 0"
            class="mt-3 text-black"
          >
            Non sono presenti immagini
          </div>
        </div> -->
        <div
          v-else-if="selectedTab === 'Video'"
          class="col-12 px-0 text-center"
        >
          <slider
            style="height: 250px"
            animation="fade"
            :autoplay="false"
            v-if="item.mediaYT !== undefined && item.mediaYT.length !== 0"
          >
            <slider-item v-for="(media, index) in item.mediaYT" :key="index">
              <div>
                <iframe
                  class="embed-responsive-item"
                  frameborder="0"
                  :src="videoSource()"
                  allowfullscreen
                  style="
                    overflow: hidden;
                    overflow-x: hidden;
                    overflow-y: hidden;
                    height: 100%;
                    width: 100%;
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                    bottom: 0px;
                    border-radius: 10px;
                    margin-y: auto;
                  "
                  height="100%"
                  width="100%"
                ></iframe>
              </div>
            </slider-item>
          </slider>

          <!-- <swiper
            v-if="item.mediaYT !== undefined && item.mediaYT.length !== 0"
            ref="mySwiper"
            class="swiper"
            navigation
            :pagination="{ clickable: true }"
            style="background-color: hsl(17, 100%, 90%); border-radius: 10px"
          >
            <swiper-slide
              v-for="(media, index) in item.mediaYT"
              :key="index"
              :style="[isLarge ? { height: '210px' } : { overflow: 'auto' }]"
            >
              <div class="embed-responsive embed-responsive-16by9">
                <iframe
                  class="embed-responsive-item"
                  frameborder="0"
                  :src="videoSource()"
                  allowfullscreen
                  style="
                    overflow: hidden;
                    overflow-x: hidden;
                    overflow-y: hidden;
                    height: 100%;
                    width: 100%;
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                    bottom: 0px;
                    border-radius: 10px;
                    margin-y: auto;
                  "
                  height="100%"
                  width="100%"
                ></iframe>
              </div>
            </swiper-slide>

            <div
              v-if="item.mediaYT.length > 1"
              class="swiper-button-prev"
              slot="button-prev"
              @click="swiper.slidePrev()"
            ></div>
            <div
              v-if="item.mediaYT.length > 1"
              class="swiper-button-next"
              slot="button-next"
              @click="swiper.slideNext()"
            ></div>
          </swiper> -->

          <div
            v-if="item.mediaYT === undefined || item.mediaYT.length === 0"
            class="mt-3 text-black"
          >
            Non sono presenti video
          </div>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
const Common = require("@/Common.vue").default;
import Card from "../Cards/Card.vue";
import $ from "jquery";
import { isMobile } from "mobile-device-detect";

import { config } from "../../utils/config";
import { Slider, SliderItem } from "vue-easy-slider";

export default {
  name: "strumento",
  props: ["item", "indexOfStrumento", "hasCorrectAmbito", "screenSize"],

  components: {
    Card,
    Slider,
    SliderItem,
  },

  data() {
    return {
      selectedTab: "Descrizione",
      isLoadingImages: true,
      isLoadingVideos: true,
      windowWidth: 0,
      isMobile: false,
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      isGeodidalab: false,
    };
  },

  created() {
    this.isMobile = isMobile;

    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });

    this.isGeodidalab = config.isGeodidalab;
  },

  mounted() {
    var self = this;

    Common.getElementImages(this, this.item, (mediaList) => {
      this.item.media = mediaList;
      self.isLoadingImages = false;
    });

    Common.getElementYTVideos(this, this.item, (ytVideoList) => {
      this.item.mediaYT = ytVideoList;
      self.isLoadingVideos = false;
    });
  },

  methods: {
    videoSource: function () {
      if (this.item["mediaYT"][0]["o:source"].includes("youtu.be/"))
        return (
          "https://youtube.com/embed/" +
          this.item["mediaYT"][0]["o:source"].split("/").pop() +
          "?modestbranding=1&playsinline=1&rel=0"
        );
      else
        return (
          "https://youtube.com/embed/" +
          this.item["mediaYT"][0]["o:source"].split("/watch?v=").pop() +
          "?modestbranding=1&playsinline=1&rel=0"
        );
    },
  },

  computed: {
    swiper() {
      return this.$refs.mySwiperStrumenti.$swiper;
    },
    isLarge() {
      return this.windowWidth >= 768;
    },
  },
};
</script>

<style scoped>
.img {
  align-items: center;
  height: 100%;
  object-fit: cover;
  /* cover makes the image stretch the width and height of the container */
  border-radius: 10px;
}

.text {
  overflow: scroll;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  /* number of lines to show */
  line-clamp: 4;
  -webkit-box-orient: vertical;
}
</style>
